module.exports = __webpack_public_path__ + "static/img02-1bee8b079303bc6806f7987b52ffaad7.jpg";